var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useState } from 'react';
import FormHelperText from '@mui/material/FormHelperText';
import HelpIcon from '@mui/icons-material/Help';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FieldLabel from '../FieldLabel';
import FieldDescription from '../FieldDescription';
import { Spacer } from '../../misc/Spacer';
import useEmotionStyles from '../../hooks/useEmotionStyles';
var styles = function (theme) { return ({
    markOfOptional: {
        color: theme.palette.grey[600],
    },
}); };
export var FieldBoxHeader = function (_a) {
    var name = _a.name, label = _a.label, description = _a.description, isOptional = _a.isOptional;
    var _b = useState(false), isExpanded = _b[0], setIsExpanded = _b[1];
    var handleExpandBtnClick = useCallback(function () {
        setIsExpanded(!isExpanded);
    }, [isExpanded]);
    var cs = useEmotionStyles(styles);
    return (React.createElement(React.Fragment, null,
        !!label && (React.createElement(Box, { sx: {
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'baseline',
            } },
            React.createElement(Box, { mr: 0.5 },
                React.createElement(FieldLabel, { htmlFor: name || '' }, label)),
            isOptional && (React.createElement(Box, { mr: 0.5 },
                React.createElement(Typography, { variant: 'body2', className: cs.markOfOptional }, "(optional)"))),
            !!description && (React.createElement(HelpIcon, { color: 'secondary', sx: {
                    fontSize: '1rem',
                    opacity: 0.4,
                    cursor: 'pointer',
                }, onClick: handleExpandBtnClick })))),
        !!description && (React.createElement("div", { onClick: handleExpandBtnClick },
            React.createElement(FieldDescription, { expanded: isExpanded }, description))),
        React.createElement(Spacer, { size: 1 })));
};
var FieldBox = function (props) {
    var name = props.name, error = props.error, children = props.children;
    return (React.createElement("div", { "data-field-name": name },
        React.createElement(FieldBoxHeader, __assign({}, props)),
        React.createElement("div", null, children),
        error && (React.createElement(FormHelperText, { id: name, error: true }, error)),
        React.createElement(Spacer, { size: 2 })));
};
export default FieldBox;
